import React from 'react';
import { SiteInfo } from '@/globals';
import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="mt-24 border-t border-black/10 bg-[#101820] text-white">
      <div className="mx-auto max-w-[1360px] px-4 py-10 text-left sm:px-6 lg:px-8">
        <div className="grid gap-8 lg:grid-cols-[1.2fr_0.8fr_0.8fr]">
          <section>
            <a href="/" className="inline-flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-white text-lg font-black text-[#101820]">P</span>
              <span>
                <span className="block text-2xl font-black">{SiteInfo.siteName}</span>
                <span className="block text-xs font-semibold text-[#ff7a59]">{SiteInfo.tagline}</span>
              </span>
            </a>
            <p className="mt-4 max-w-xl text-sm leading-6 text-white/70">{t("footerPromise")}</p>
            <p className="mt-3 max-w-xl text-xs leading-5 text-white/55">{t("affiliateDisclosure")}</p>
          </section>

          <section aria-label={t("footerBrowse")}>
            <h2 className="text-xs font-semibold uppercase tracking-normal text-white/45">{t("footerBrowse")}</h2>
            <div className="mt-3 grid gap-2 text-sm font-semibold text-white/80">
              <a href="/" className="hover:text-white">{t("hotDeals")}</a>
              <a href="/brands" className="hover:text-white">{t("brands")}</a>
              <a href="/promotions" className="hover:text-white">{t("promotions")}</a>
              <a href="/about" className="hover:text-white">{t("about")}</a>
            </div>
          </section>

          <section aria-label={t("trustSignals")}>
            <h2 className="text-xs font-semibold uppercase tracking-normal text-white/45">{t("trustSignals")}</h2>
            <div className="mt-3 grid gap-2 text-sm text-white/75">
              <p>{t("curationDiscount")}</p>
              <p>{t("curationDemand")}</p>
              <a href={`mailto:${SiteInfo.supportEmail}`} className="font-semibold text-white hover:text-[#ff7a59]">{SiteInfo.supportEmail}</a>
            </div>
          </section>
        </div>

        <div className="mt-8 border-t border-white/10 pt-5 text-xs leading-5 text-white/45">
          <p>{t("footerCopyright", { siteName: SiteInfo.siteName })}</p>
          <p>{t("footerText", { siteName: SiteInfo.siteName })}</p>
        </div>
        <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1 text-sm">
          <a href="/termsOfService" className="text-white/70 underline hover:text-white">{t("termsOfService")}</a>
          <a href="/privacyPolicy" className="text-white/70 underline hover:text-white">{t("privacyPolicy")}</a>
        </div>
      </div>
    </footer>
  )
}
